'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _menu=require('./components/menu');exports.default=_menu.ColorPickerMenu;